import {Button, Modal, Stack, Text, Textarea, TextInput, Title} from "@mantine/core";
import {Task} from "../../api/task/Task";
import DateTimeView from "../../components/date/DateTimeView";
import dayjs from "dayjs";
import arraySupport from "dayjs/plugin/arraySupport";
import utc from "dayjs/plugin/utc";

interface TaskPreviewProps {
    task?: Task;
    isOpen: boolean;
    onClose: () => void;
}

const formatDate = (data: any) => {
    dayjs.extend(arraySupport);
    dayjs.extend(utc);

    if (!data) {
        return "-";
    }

    let date = dayjs.utc(new Date(
        data[0],
        data[1] - 1,
        data[2],
        data[3],
        data[4],
        data[5],
        data[6] / 1000000
    ));

    date = date.add(2, 'hour');
    return date.format('YYYY-MM-DD HH:mm')
}

function TaskPreview({task, isOpen, onClose}: TaskPreviewProps) {
    return (
        <Modal opened={isOpen} onClose={onClose} title={<Title order={4}>Szczegóły zadania</Title>}>
            <Stack>
                <Textarea
                    readOnly
                    label="Opis zadania"
                    value={task?.description}
                />

                <TextInput
                    readOnly
                    label="Przypisanie"
                    value={task?.assignedTo?.username || "-"}
                />

                <TextInput
                    readOnly
                    label="Zakończono przez"
                    value={task?.finishedBy?.username || "-"}
                />

                <TextInput
                    readOnly
                    label="Data wykonania"
                    value={
                        formatDate(task?.finishedAt)
                    }
                />

                <Button fullWidth onClick={onClose}>
                    Zamknij
                </Button>
            </Stack>
        </Modal>
    );
}

export default TaskPreview;